import type { FC } from "react";

import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";

import { DeviceDistributionChartTitle } from "../../components/DeviceDistributionChartTitle/DeviceDistributionChartTitle";
import { useDeviceDistributionData } from "../../hooks/useDeviceDistributionData";

import { ChartBody } from "./components/ChartBody/ChartBody";
import { ChartContainer } from "./DeviceDistributionSingleChart.styles";

interface IDeviceDistributionSingleChartProps {
    webSource: WebSource;
}

export const DeviceDistributionSingleChart: FC<IDeviceDistributionSingleChartProps> = (props) => {
    const { webSource } = props;

    const { data, isLoading } = useDeviceDistributionData();

    return (
        <>
            <DeviceDistributionChartTitle webSource={webSource} />
            <ChartContainer>
                <ChartBody
                    webSource={webSource}
                    isLoading={isLoading}
                    data={data}
                />
            </ChartContainer>
        </>
    );
};
